import { useEffect, useRef } from "react";
import { loadConfig } from "@/modules/homeDisplay/services";
import { useUserDataFlattened } from "../../../modules/user/stores";

/**
 * 通用倒计时结束监听 Hook
 * 当倒计时到0时自动调用 loadConfig 刷新活动配置
 * @param remainingMs - 剩余毫秒数，可以是单个值或数组
 */
export const useCountdownEndListener = (remainingMs: number | number[]) => {
  const { loadUserRealtime } = useUserDataFlattened();
  const timersRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    // 清除所有之前的定时器
    timersRef.current.forEach(timer => clearTimeout(timer));
    timersRef.current = [];

    // 将输入标准化为数组
    const remainingMsArray = Array.isArray(remainingMs)
      ? remainingMs
      : [remainingMs];

    // 为每个有效的倒计时设置定时器
    remainingMsArray.forEach(ms => {
      // 如果倒计时已经结束或无效，跳过
      if (!ms || ms <= 0 || !Number.isFinite(ms)) {
        return;
      }

      // 设置定时器，在倒计时结束时刷新配置
      const timer = setTimeout(async () => {
        try {
          await loadUserRealtime();
          await loadConfig();
        } catch (error) {
          console.error("[CountdownEndListener] 刷新数据失败:", error);
        }
      }, ms);

      timersRef.current.push(timer);
    });

    return () => {
      timersRef.current.forEach(timer => clearTimeout(timer));
      timersRef.current = [];
    };
  }, [JSON.stringify(remainingMs), loadUserRealtime]);
};
